import { Box } from '@mui/material';
import HeaderNotifications from './Notifications';

function HeaderButtons() {
  return (
    <Box>
      <HeaderNotifications />
      {/*<LanguageSwitcher />*/}
      {/*<Chat />*/}
    </Box>
  );
}

export default HeaderButtons;
